import React from 'react';

import SaleBaseCozyGame from './SaleBaseCozyGame';
function MarketplaceCozyGame() {
  return <SaleBaseCozyGame saleType="Marketplace" />;
}

export default MarketplaceCozyGame;